import { useState } from 'react';
import EnableSwitchConfig from '../../components/shared/others/EnableSwitchConfig';
import { createOrUpdateIdpConfig } from '../api/idp_config';
import ErrorBox from '../../components/shared/boxes/ErrorBox';

const selectSwitch = (event, successCallback, errorCallback) => {
  const updatedConfig = {
    allow_sso_only_login: event.target.checked,
  };

  createOrUpdateIdpConfig({
    idpConfig: updatedConfig,
    successCallback: successCallback,
    errorCallback: errorCallback,
  });
};

const SettingsSwitch = ({ config }) => {
  const [configApiError, setConfigApiError] = useState({});

  const successCallback = () => {};
  const errorCallback = (errorMessage) => setConfigApiError({ errorMessage: errorMessage });

  return (
    <>
      {config?.canSwitchSsoOnlyPreference && (
        <>
          {configApiError.errorMessage && (
            <ErrorBox errorMessage={configApiError.errorMessage} onClose={() => setConfigApiError({})} />
          )}

          <EnableSwitchConfig
            onChange={(event) => selectSwitch(event, successCallback, errorCallback)}
            defaultChecked={config?.allowSsoOnlyLogin}
            label="Ativar obrigatoriedade para todos os usuários da conta"
          />
        </>
      )}
    </>
  );
};

export default SettingsSwitch;
